webpackJsonp([4],{

/***/ 106:
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

module.exports = __webpack_require__(316);

/***/ }),

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__community_timeline_components_column_settings__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_settings__ = __webpack_require__(111);




var mapStateToProps = function mapStateToProps(state) {
  return {
    settings: state.getIn(['settings', 'public'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(key, checked) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_settings__["b" /* changeSetting */])(['public'].concat(key), checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__community_timeline_components_column_settings__["a" /* default */]));

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var events = __webpack_require__(106);
var precond = __webpack_require__(107);
var util = __webpack_require__(39);

// A class to hold the state of a backoff operation. Accepts a backoff strategy
// to generate the backoff delays.
function Backoff(backoffStrategy) {
    events.EventEmitter.call(this);

    this.backoffStrategy_ = backoffStrategy;
    this.maxNumberOfRetry_ = -1;
    this.backoffNumber_ = 0;
    this.backoffDelay_ = 0;
    this.timeoutID_ = -1;

    this.handlers = {
        backoff: this.onBackoff_.bind(this)
    };
}
util.inherits(Backoff, events.EventEmitter);

// Sets a limit, greater than 0, on the maximum number of backoffs. A 'fail'
// event will be emitted when the limit is reached.
Backoff.prototype.failAfter = function(maxNumberOfRetry) {
    precond.checkArgument(maxNumberOfRetry > 0,
        'Expected a maximum number of retry greater than 0 but got %s.',
        maxNumberOfRetry);

    this.maxNumberOfRetry_ = maxNumberOfRetry;
};

// Starts a backoff operation. Accepts an optional parameter to let the
// listeners know why the backoff operation was started.
Backoff.prototype.backoff = function(err) {
    precond.checkState(this.timeoutID_ === -1, 'Backoff in progress.');

    if (this.backoffNumber_ === this.maxNumberOfRetry_) {
        this.emit('fail', err);
        this.reset();
    } else {
        this.backoffDelay_ = this.backoffStrategy_.next();
        this.timeoutID_ = setTimeout(this.handlers.backoff, this.backoffDelay_);
        this.emit('backoff', this.backoffNumber_, this.backoffDelay_, err);
    }
};

// Handles the backoff timeout completion.
Backoff.prototype.onBackoff_ = function() {
    this.timeoutID_ = -1;
    this.emit('ready', this.backoffNumber_, this.backoffDelay_);
    this.backoffNumber_++;
};

// Stops any backoff operation and resets the backoff delay to its inital value.
Backoff.prototype.reset = function() {
    this.backoffNumber_ = 0;
    this.backoffStrategy_.reset();
    clearTimeout(this.timeoutID_);
    this.timeoutID_ = -1;
};

module.exports = Backoff;


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var events = __webpack_require__(106);
var util = __webpack_require__(39);

function isDef(value) {
    return value !== undefined && value !== null;
}

// Abstract class defining the skeleton for the backoff strategies. Accepts an
// object holding the options for the backoff strategy:
//
//  * `randomisationFactor`: The randomisation factor which must be between 0
//     and 1 where 1 equates to a randomization factor of 100% and 0 to no
//     randomization.
//  * `initialDelay`: The backoff initial delay in milliseconds.
//  * `maxDelay`: The backoff maximal delay in milliseconds.
function BackoffStrategy(options) {
    options = options || {};

    if (isDef(options.initialDelay) && options.initialDelay < 1) {
        throw new Error('The initial timeout must be greater than 0.');
    } else if (isDef(options.maxDelay) && options.maxDelay < 1) {
        throw new Error('The maximal timeout must be greater than 0.');
    }

    this.initialDelay_ = options.initialDelay || 100;
    this.maxDelay_ = options.maxDelay || 10000;

    if (this.maxDelay_ <= this.initialDelay_) {
        throw new Error('The maximal backoff delay must be ' +
                        'greater than the initial backoff delay.');
    }

    if (isDef(options.randomisationFactor) &&
        (options.randomisationFactor < 0 || options.randomisationFactor > 1)) {
        throw new Error('The randomisation factor must be between 0 and 1.');
    }

    this.randomisationFactor_ = options.randomisationFactor || 0;
}

// Gets the maximal backoff delay.
BackoffStrategy.prototype.getMaxDelay = function() {
    return this.maxDelay_;
};

// Gets the initial backoff delay.
BackoffStrategy.prototype.getInitialDelay = function() {
    return this.initialDelay_;
};

// Template method that computes and returns the next backoff delay in
// milliseconds.
BackoffStrategy.prototype.next = function() {
    var backoffDelay = this.next_();
    var randomisationMultiple = 1 + Math.random() * this.randomisationFactor_;
    var randomizedDelay = Math.round(backoffDelay * randomisationMultiple);
    return randomizedDelay;
};

// Computes and returns the next backoff delay. Intended to be overridden by
// subclasses.
BackoffStrategy.prototype.next_ = function() {
    throw new Error('BackoffStrategy.next_() unimplemented.');
};

// Template method that resets the backoff delay to its initial value.
BackoffStrategy.prototype.reset = function() {
    this.reset_();
};

// Resets the backoff delay to its initial value. Intended to be overridden by
// subclasses.
BackoffStrategy.prototype.reset_ = function() {
    throw new Error('BackoffStrategy.reset_() unimplemented.');
};

module.exports = BackoffStrategy;


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var util = __webpack_require__(39);

var BackoffStrategy = __webpack_require__(170);

// Fibonacci backoff strategy.
function FibonacciBackoffStrategy(options) {
    BackoffStrategy.call(this, options);
    this.backoffDelay_ = 0;
    this.nextBackoffDelay_ = this.getInitialDelay();
}
util.inherits(FibonacciBackoffStrategy, BackoffStrategy);

FibonacciBackoffStrategy.prototype.next_ = function() {
    var backoffDelay = Math.min(this.nextBackoffDelay_, this.getMaxDelay());
    this.nextBackoffDelay_ += this.backoffDelay_;
    this.backoffDelay_ = backoffDelay;
    return backoffDelay;
};

FibonacciBackoffStrategy.prototype.reset_ = function() {
    this.nextBackoffDelay_ = this.getInitialDelay();
    this.backoffDelay_ = 0;
};

module.exports = FibonacciBackoffStrategy;


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ScrollContext = exports.ScrollContainer = undefined;

var _ScrollContainer2 = __webpack_require__(296);

var _ScrollContainer3 = _interopRequireDefault(_ScrollContainer2);

var _ScrollBehaviorContext = __webpack_require__(168);

var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ScrollContainer = _ScrollContainer3.default;
exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  scrollKey: _react2.default.PropTypes.string.isRequired,
  shouldUpdateScroll: _react2.default.PropTypes.func,
  children: _react2.default.PropTypes.element.isRequired
};

var contextTypes = {
  // This is necessary when rendering on the client. However, when rendering on
  // the server, this container will do nothing, and thus does not require the
  // scroll behavior context.
  scrollBehavior: _react2.default.PropTypes.object
};

var ScrollContainer = function (_React$Component) {
  _inherits(ScrollContainer, _React$Component);

  function ScrollContainer(props, context) {
    _classCallCheck(this, ScrollContainer);

    // We don't re-register if the scroll key changes, so make sure we
    // unregister with the initial scroll key just in case the user changes it.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
      var shouldUpdateScroll = _this.props.shouldUpdateScroll;

      if (!shouldUpdateScroll) {
        return true;
      }

      // Hack to allow accessing scrollBehavior._stateStorage.
      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
    };

    _this.scrollKey = props.scrollKey;
    return _this;
  }

  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
    this.shouldUpdateScroll);

    // Only keep around the current DOM node in development, as this is only
    // for emitting the appropriate warning.
    if (false) {
      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    }
  };

  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, '<ScrollContainer> does not support changing scrollKey.') : void 0;
  };

  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
    if (false) {
      var prevDomNode = this.domNode;
      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(this.domNode === prevDomNode, '<ScrollContainer> does not support changing DOM node.') : void 0;
    }
  };

  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.context.scrollBehavior.unregisterElement(this.scrollKey);
  };

  ScrollContainer.prototype.render = function render() {
    return this.props.children;
  };

  return ScrollContainer;
}(_react2.default.Component);

ScrollContainer.propTypes = propTypes;
ScrollContainer.contextTypes = contextTypes;

exports.default = ScrollContainer;
module.exports = exports['default'];

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadMore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);





var _class, _temp;



var LoadMore = (_temp = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LoadMore, _React$PureComponent);

  function LoadMore() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoadMore);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.apply(this, arguments));
  }

  LoadMore.prototype.render = function render() {
    var visible = this.props.visible;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      className: 'load-more',
      disabled: !visible,
      style: { visibility: visible ? 'visible' : 'hidden' },
      onClick: this.props.onClick
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'status.load_more',
      defaultMessage: 'Load more'
    }));
  };

  return LoadMore;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  visible: true
}, _temp);


/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_status__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_interactions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_accounts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_statuses__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_reports__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_modal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);













var messages = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["f" /* defineMessages */])({
  deleteConfirm: {
    'id': 'confirmations.delete.confirm',
    'defaultMessage': 'Delete'
  },
  deleteMessage: {
    'id': 'confirmations.delete.message',
    'defaultMessage': 'Are you sure you want to delete this status?'
  },
  blockConfirm: {
    'id': 'confirmations.block.confirm',
    'defaultMessage': 'Block'
  },
  muteConfirm: {
    'id': 'confirmations.mute.confirm',
    'defaultMessage': 'Mute'
  }
});

var makeMapStateToProps = function makeMapStateToProps() {
  var getStatus = Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["e" /* makeGetStatus */])();

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      status: getStatus(state, props.id),
      me: state.getIn(['meta', 'me']),
      boostModal: state.getIn(['meta', 'boost_modal']),
      deleteModal: state.getIn(['meta', 'delete_modal']),
      autoPlayGif: state.getIn(['meta', 'auto_play_gif'])
    };
  };

  return mapStateToProps;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var intl = _ref.intl;
  return {
    onReply: function onReply(status, router) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_compose__["L" /* replyCompose */])(status, router));
    },
    onModalReblog: function onModalReblog(status) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["q" /* reblog */])(status));
    },
    onReblog: function onReblog(status, e) {
      if (status.get('reblogged')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["t" /* unreblog */])(status));
      } else {
        if (e.shiftKey || !this.boostModal) {
          this.onModalReblog(status);
        } else {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('BOOST', { status: status, onReblog: this.onModalReblog }));
        }
      }
    },
    onFavourite: function onFavourite(status) {
      if (status.get('favourited')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["r" /* unfavourite */])(status));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["m" /* favourite */])(status));
      }
    },
    onPin: function onPin(status) {
      if (status.get('pinned')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["s" /* unpin */])(status));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["p" /* pin */])(status));
      }
    },
    onEmbed: function onEmbed(status) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('EMBED', { url: status.get('url') }));
    },
    onDelete: function onDelete(status) {
      if (!this.deleteModal) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["e" /* deleteStatus */])(status.get('id')));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('CONFIRM', {
          message: intl.formatMessage(messages.deleteMessage),
          confirm: intl.formatMessage(messages.deleteConfirm),
          onConfirm: function onConfirm() {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["e" /* deleteStatus */])(status.get('id')));
          }
        }));
      }
    },
    onMention: function onMention(account, router) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_compose__["J" /* mentionCompose */])(account, router));
    },
    onOpenMedia: function onOpenMedia(media, index) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('MEDIA', { media: media, index: index }));
    },
    onOpenVideo: function onOpenVideo(media, time) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('VIDEO', { media: media, time: time }));
    },
    onBlock: function onBlock(account) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('CONFIRM', {
        message: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_intl__["b" /* FormattedMessage */], {
          id: 'confirmations.block.message',
          defaultMessage: 'Are you sure you want to block {name}?',
          values: { name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('strong', {}, void 0, '@', account.get('acct')) }
        }),
        confirm: intl.formatMessage(messages.blockConfirm),
        onConfirm: function onConfirm() {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_accounts__["r" /* blockAccount */])(account.get('id')));
        }
      }));
    },
    onReport: function onReport(status) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_reports__["i" /* initReport */])(status.get('account'), status));
    },
    onMute: function onMute(account) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('CONFIRM', {
        message: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_intl__["b" /* FormattedMessage */], {
          id: 'confirmations.mute.message',
          defaultMessage: 'Are you sure you want to mute {name}?',
          values: { name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('strong', {}, void 0, '@', account.get('acct')) }
        }),
        confirm: intl.formatMessage(messages.muteConfirm),
        onConfirm: function onConfirm() {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_accounts__["B" /* muteAccount */])(account.get('id')));
        }
      }));
    },
    onMuteConversation: function onMuteConversation(status) {
      if (status.get('muted')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["h" /* unmuteStatus */])(status.get('id')));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["g" /* muteStatus */])(status.get('id')));
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["g" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_status__["a" /* default */])));

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_scroll__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_intersection_observer_article_container__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__load_more__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__features_ui_util_intersection_observer_wrapper__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_immutable__);






var _class, _temp2;










var ScrollableList = (_temp2 = _class = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ScrollableList, _PureComponent);

  function ScrollableList() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      lastMouseMove: null
    }, _this.intersectionObserverWrapper = new __WEBPACK_IMPORTED_MODULE_10__features_ui_util_intersection_observer_wrapper__["a" /* default */](), _this.handleScroll = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function () {
      if (_this.node) {
        var _this$node = _this.node,
            scrollTop = _this$node.scrollTop,
            scrollHeight = _this$node.scrollHeight,
            clientHeight = _this$node.clientHeight;

        var offset = scrollHeight - scrollTop - clientHeight;
        _this._oldScrollPosition = scrollHeight - scrollTop;

        if (400 > offset && _this.props.onScrollToBottom && !_this.props.isLoading) {
          _this.props.onScrollToBottom();
        } else if (scrollTop < 100 && _this.props.onScrollToTop) {
          _this.props.onScrollToTop();
        } else if (_this.props.onScroll) {
          _this.props.onScroll();
        }
      }
    }, 150, {
      trailing: true
    }), _this.handleMouseMove = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function () {
      _this._lastMouseMove = new Date();
    }, 300), _this.handleMouseLeave = function () {
      _this._lastMouseMove = null;
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _this.handleLoadMore = function (e) {
      e.preventDefault();
      _this.props.onScrollToBottom();
    }, _this.handleKeyDown = function (e) {
      if (['PageDown', 'PageUp'].includes(e.key) || e.ctrlKey && ['End', 'Home'].includes(e.key)) {
        var article = function () {
          switch (e.key) {
            case 'PageDown':
              return e.target.nodeName === 'ARTICLE' && e.target.nextElementSibling;
            case 'PageUp':
              return e.target.nodeName === 'ARTICLE' && e.target.previousElementSibling;
            case 'End':
              return _this.node.querySelector('[role="feed"] > article:last-of-type');
            case 'Home':
              return _this.node.querySelector('[role="feed"] > article:first-of-type');
            default:
              return null;
          }
        }();

        if (article) {
          e.preventDefault();
          article.focus();
          article.scrollIntoView();
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ScrollableList.prototype.componentDidMount = function componentDidMount() {
    this.attachScrollListener();
    this.attachIntersectionObserver();

    // Handle initial scroll posiiton
    this.handleScroll();
  };

  ScrollableList.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var someItemInserted = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(prevProps.children) > 0 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(prevProps.children) < __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children) && this.getFirstChildKey(prevProps) !== this.getFirstChildKey(this.props);

    // Reset the scroll position when a new child comes in in order not to
    // jerk the scrollbar around if you're already scrolled down the page.
    if (someItemInserted && this._oldScrollPosition && this.node.scrollTop > 0) {
      var newScrollTop = this.node.scrollHeight - this._oldScrollPosition;

      if (this.node.scrollTop !== newScrollTop) {
        this.node.scrollTop = newScrollTop;
      }
    } else {
      this._oldScrollPosition = this.node.scrollHeight - this.node.scrollTop;
    }
  };

  ScrollableList.prototype.componentWillUnmount = function componentWillUnmount() {
    this.detachScrollListener();
    this.detachIntersectionObserver();
  };

  ScrollableList.prototype.attachIntersectionObserver = function attachIntersectionObserver() {
    this.intersectionObserverWrapper.connect({
      root: this.node,
      rootMargin: '300% 0px'
    });
  };

  ScrollableList.prototype.detachIntersectionObserver = function detachIntersectionObserver() {
    this.intersectionObserverWrapper.disconnect();
  };

  ScrollableList.prototype.attachScrollListener = function attachScrollListener() {
    this.node.addEventListener('scroll', this.handleScroll);
  };

  ScrollableList.prototype.detachScrollListener = function detachScrollListener() {
    this.node.removeEventListener('scroll', this.handleScroll);
  };

  ScrollableList.prototype.getFirstChildKey = function getFirstChildKey(props) {
    var children = props.children;

    var firstChild = children;
    if (children instanceof __WEBPACK_IMPORTED_MODULE_11_immutable__["List"]) {
      firstChild = children.get(0);
    } else if (Array.isArray(children)) {
      firstChild = children[0];
    }
    return firstChild && firstChild.key;
  };

  ScrollableList.prototype._recentlyMoved = function _recentlyMoved() {
    return this._lastMouseMove !== null && new Date() - this._lastMouseMove < 600;
  };

  ScrollableList.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        scrollKey = _props.scrollKey,
        trackScroll = _props.trackScroll,
        shouldUpdateScroll = _props.shouldUpdateScroll,
        isLoading = _props.isLoading,
        hasMore = _props.hasMore,
        prepend = _props.prepend,
        emptyMessage = _props.emptyMessage;

    var childrenCount = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(children);

    var loadMore = hasMore && childrenCount > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__load_more__["a" /* default */], {
      visible: !isLoading,
      onClick: this.handleLoadMore
    }) : null;
    var scrollableArea = null;

    if (isLoading || childrenCount > 0 || !emptyMessage) {
      scrollableArea = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'scrollable', ref: this.setRef, onMouseMove: this.handleMouseMove, onMouseLeave: this.handleMouseLeave },
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
          role: 'feed',
          className: 'item-list',
          onKeyDown: this.handleKeyDown
        }, void 0, prepend, __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(this.props.children, function (child, index) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__containers_intersection_observer_article_container__["a" /* default */], {
            id: child.key,
            index: index,
            listLength: childrenCount,
            intersectionObserverWrapper: _this2.intersectionObserverWrapper,
            saveHeightKey: trackScroll ? _this2.context.router.route.location.key + ':' + scrollKey : null
          }, child.key, child);
        }), loadMore)
      );
    } else {
      scrollableArea = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'empty-column-indicator', ref: this.setRef },
        emptyMessage
      );
    }

    if (trackScroll) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react_router_scroll__["ScrollContainer"], {
        scrollKey: scrollKey,
        shouldUpdateScroll: shouldUpdateScroll
      }, void 0, scrollableArea);
    } else {
      return scrollableArea;
    }
  };

  return ScrollableList;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
}, _class.defaultProps = {
  trackScroll: true
}, _temp2);


/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_intersection_observer_article__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_height_cache__ = __webpack_require__(109);




var makeMapStateToProps = function makeMapStateToProps(state, props) {
  return {
    cachedHeight: state.getIn(['height_cache', props.saveHeightKey, props.id])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onHeightChange: function onHeightChange(key, id, height) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_height_cache__["d" /* setHeight */])(key, id, height));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_intersection_observer_article__["a" /* default */]));

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntersectionObserverArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__features_ui_util_schedule_idle_task__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__features_ui_util_get_rect_from_entry__ = __webpack_require__(305);




var _class, _temp2;







var IntersectionObserverArticle = (_temp2 = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(IntersectionObserverArticle, _ImmutablePureCompone);

  function IntersectionObserverArticle() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntersectionObserverArticle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.state = {
      isHidden: false // set to true in requestIdleCallback to trigger un-render
    }, _this.handleIntersection = function (entry) {
      var _this$props = _this.props,
          onHeightChange = _this$props.onHeightChange,
          saveHeightKey = _this$props.saveHeightKey,
          id = _this$props.id;


      if (_this.node && _this.node.children.length !== 0) {
        // save the height of the fully-rendered element
        _this.height = Object(__WEBPACK_IMPORTED_MODULE_7__features_ui_util_get_rect_from_entry__["a" /* default */])(entry).height;

        if (onHeightChange && saveHeightKey) {
          onHeightChange(saveHeightKey, id, _this.height);
        }
      }

      _this.setState(function (prevState) {
        if (prevState.isIntersecting && !entry.isIntersecting) {
          Object(__WEBPACK_IMPORTED_MODULE_6__features_ui_util_schedule_idle_task__["a" /* default */])(_this.hideIfNotIntersecting);
        }
        return {
          isIntersecting: entry.isIntersecting,
          isHidden: false
        };
      });
    }, _this.hideIfNotIntersecting = function () {
      if (!_this.componentMounted) {
        return;
      }

      // When the browser gets a chance, test if we're still not intersecting,
      // and if so, set our isHidden to true to trigger an unrender. The point of
      // this is to save DOM nodes and avoid using up too much memory.
      // See: https://github.com/tootsuite/mastodon/issues/2900
      _this.setState(function (prevState) {
        return { isHidden: !prevState.isIntersecting };
      });
    }, _this.handleRef = function (node) {
      _this.node = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  IntersectionObserverArticle.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (!nextState.isIntersecting && nextState.isHidden) {
      // It's only if we're not intersecting (i.e. offscreen) and isHidden is true
      // that either "isIntersecting" or "isHidden" matter, and then they're
      // the only things that matter (and updated ARIA attributes).
      return this.state.isIntersecting || !this.state.isHidden || nextProps.listLength !== this.props.listLength;
    } else if (nextState.isIntersecting && !this.state.isIntersecting) {
      // If we're going from a non-intersecting state to an intersecting state,
      // (i.e. offscreen to onscreen), then we definitely need to re-render
      return true;
    }
    // Otherwise, diff based on "updateOnProps" and "updateOnStates"
    return _ImmutablePureCompone.prototype.shouldComponentUpdate.call(this, nextProps, nextState);
  };

  IntersectionObserverArticle.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        intersectionObserverWrapper = _props.intersectionObserverWrapper,
        id = _props.id;


    intersectionObserverWrapper.observe(id, this.node, this.handleIntersection);

    this.componentMounted = true;
  };

  IntersectionObserverArticle.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        intersectionObserverWrapper = _props2.intersectionObserverWrapper,
        id = _props2.id;

    intersectionObserverWrapper.unobserve(id, this.node);

    this.componentMounted = false;
  };

  IntersectionObserverArticle.prototype.render = function render() {
    var _props3 = this.props,
        children = _props3.children,
        id = _props3.id,
        index = _props3.index,
        listLength = _props3.listLength,
        cachedHeight = _props3.cachedHeight;
    var _state = this.state,
        isIntersecting = _state.isIntersecting,
        isHidden = _state.isHidden;


    if (!isIntersecting && (isHidden || cachedHeight)) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'article',
        {
          ref: this.handleRef,
          'aria-posinset': index,
          'aria-setsize': listLength,
          style: { height: (this.height || cachedHeight) + 'px', opacity: 0, overflow: 'hidden' },
          'data-id': id,
          tabIndex: '0'
        },
        children && __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(children, { hidden: true })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'article',
      { ref: this.handleRef, 'aria-posinset': index, 'aria-setsize': listLength, 'data-id': id, tabIndex: '0' },
      children && __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(children, { hidden: false })
    );
  };

  return IntersectionObserverArticle;
}(__WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component___default.a), _class.propTypes = {
  intersectionObserverWrapper: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  index: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  listLength: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  saveHeightKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cachedHeight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  onHeightChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
}, _temp2);


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_queue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tiny_queue__);
// Wrapper to call requestIdleCallback() to schedule low-priority work.
// See https://developer.mozilla.org/en-US/docs/Web/API/Background_Tasks_API
// for a good breakdown of the concepts behind this.



var taskQueue = new __WEBPACK_IMPORTED_MODULE_0_tiny_queue___default.a();
var runningRequestIdleCallback = false;

function runTasks(deadline) {
  while (taskQueue.length && deadline.timeRemaining() > 0) {
    taskQueue.shift()();
  }
  if (taskQueue.length) {
    requestIdleCallback(runTasks);
  } else {
    runningRequestIdleCallback = false;
  }
}

function scheduleIdleTask(task) {
  taskQueue.push(task);
  if (!runningRequestIdleCallback) {
    runningRequestIdleCallback = true;
    requestIdleCallback(runTasks);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (scheduleIdleTask);

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Simple FIFO queue implementation to avoid having to do shift()
// on an array, which is slow.

function Queue() {
  this.length = 0;
}

Queue.prototype.push = function (item) {
  var node = {item: item};
  if (this.last) {
    this.last = this.last.next = node;
  } else {
    this.last = this.first = node;
  }
  this.length++;
};

Queue.prototype.shift = function () {
  var node = this.first;
  if (node) {
    this.first = node.next;
    if (!(--this.length)) {
      this.last = undefined;
    }
    return node.item;
  }
};

Queue.prototype.slice = function (start, end) {
  start = typeof start === 'undefined' ? 0 : start;
  end = typeof end === 'undefined' ? Infinity : end;

  var output = [];

  var i = 0;
  for (var node = this.first; node; node = node.next) {
    if (--end < 0) {
      break;
    } else if (++i > start) {
      output.push(node.item);
    }
  }
  return output;
}

module.exports = Queue;


/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Get the bounding client rect from an IntersectionObserver entry.
// This is to work around a bug in Chrome: https://crbug.com/737228

var hasBoundingRectBug = void 0;

function getRectFromEntry(entry) {
  if (typeof hasBoundingRectBug !== 'boolean') {
    var boundingRect = entry.target.getBoundingClientRect();
    var observerRect = entry.boundingClientRect;
    hasBoundingRectBug = boundingRect.height !== observerRect.height || boundingRect.top !== observerRect.top || boundingRect.width !== observerRect.width || boundingRect.bottom !== observerRect.bottom || boundingRect.left !== observerRect.left || boundingRect.right !== observerRect.right;
  }
  return hasBoundingRectBug ? entry.target.getBoundingClientRect() : entry.boundingClientRect;
}

/* harmony default export */ __webpack_exports__["a"] = (getRectFromEntry);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


// Wrapper for IntersectionObserver in order to make working with it
// a bit easier. We also follow this performance advice:
// "If you need to observe multiple elements, it is both possible and
// advised to observe multiple elements using the same IntersectionObserver
// instance by calling observe() multiple times."
// https://developers.google.com/web/updates/2016/04/intersectionobserver

var IntersectionObserverWrapper = function () {
  function IntersectionObserverWrapper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntersectionObserverWrapper);

    this.callbacks = {};
    this.observerBacklog = [];
    this.observer = null;
  }

  IntersectionObserverWrapper.prototype.connect = function connect(options) {
    var _this = this;

    var onIntersection = function onIntersection(entries) {
      entries.forEach(function (entry) {
        var id = entry.target.getAttribute('data-id');
        if (_this.callbacks[id]) {
          _this.callbacks[id](entry);
        }
      });
    };

    this.observer = new IntersectionObserver(onIntersection, options);
    this.observerBacklog.forEach(function (_ref) {
      var id = _ref[0],
          node = _ref[1],
          callback = _ref[2];

      _this.observe(id, node, callback);
    });
    this.observerBacklog = null;
  };

  IntersectionObserverWrapper.prototype.observe = function observe(id, node, callback) {
    if (!this.observer) {
      this.observerBacklog.push([id, node, callback]);
    } else {
      this.callbacks[id] = callback;
      this.observer.observe(node);
    }
  };

  IntersectionObserverWrapper.prototype.unobserve = function unobserve(id, node) {
    if (this.observer) {
      delete this.callbacks[id];
      this.observer.unobserve(node);
    }
  };

  IntersectionObserverWrapper.prototype.disconnect = function disconnect() {
    if (this.observer) {
      this.callbacks = {};
      this.observer.disconnect();
      this.observer = null;
    }
  };

  return IntersectionObserverWrapper;
}();

/* harmony default export */ __webpack_exports__["a"] = (IntersectionObserverWrapper);

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_status_container__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_immutable_pure_component__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scrollable_list__ = __webpack_require__(300);






var _class, _temp;








var StatusList = (_temp = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StatusList, _ImmutablePureCompone);

  function StatusList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StatusList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  StatusList.prototype.render = function render() {
    var _props = this.props,
        statusIds = _props.statusIds,
        other = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['statusIds']);

    var isLoading = other.isLoading;


    var scrollableContent = isLoading || statusIds.size > 0 ? statusIds.map(function (statusId) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__containers_status_container__["a" /* default */], {
        id: statusId
      }, statusId);
    }) : null;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__scrollable_list__["a" /* default */],
      other,
      scrollableContent
    );
  };

  return StatusList;
}(__WEBPACK_IMPORTED_MODULE_9_react_immutable_pure_component___default.a), _class.propTypes = {
  scrollKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  statusIds: __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default.a.list.isRequired,
  onScrollToBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onScrollToTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onScroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  trackScroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  shouldUpdateScroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  isLoading: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hasMore: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prepend: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  emptyMessage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
}, _class.defaultProps = {
  trackScroll: true
}, _temp);


/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_status_list__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_timelines__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reselect__);








var makeGetStatusIds = function makeGetStatusIds() {
  return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([function (state, _ref) {
    var type = _ref.type;
    return state.getIn(['settings', type], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])());
  }, function (state, _ref2) {
    var type = _ref2.type;
    return state.getIn(['timelines', type, 'items'], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])());
  }, function (state) {
    return state.get('statuses');
  }, function (state) {
    return state.getIn(['meta', 'me']);
  }], function (columnSettings, statusIds, statuses, me) {
    var rawRegex = columnSettings.getIn(['regex', 'body'], '').trim();
    var regex = null;

    try {
      regex = rawRegex && new RegExp(rawRegex, 'i');
    } catch (e) {
      // Bad regex, don't affect filters
    }

    return statusIds.filter(function (id) {
      var statusForId = statuses.get(id);
      var showStatus = true;

      if (columnSettings.getIn(['shows', 'reblog']) === false) {
        showStatus = showStatus && statusForId.get('reblog') === null;
      }

      if (columnSettings.getIn(['shows', 'reply']) === false) {
        showStatus = showStatus && (statusForId.get('in_reply_to_id') === null || statusForId.get('in_reply_to_account_id') === me);
      }

      if (showStatus && regex && statusForId.get('account') !== me) {
        var searchIndex = statusForId.get('reblog') ? statuses.getIn([statusForId.get('reblog'), 'search_index']) : statusForId.get('search_index');
        showStatus = !regex.test(searchIndex);
      }

      return showStatus;
    });
  });
};

var makeMapStateToProps = function makeMapStateToProps() {
  var getStatusIds = makeGetStatusIds();

  var mapStateToProps = function mapStateToProps(state, _ref3) {
    var timelineId = _ref3.timelineId;
    return {
      statusIds: getStatusIds(state, { type: timelineId }),
      isLoading: state.getIn(['timelines', timelineId, 'isLoading'], true),
      hasMore: !!state.getIn(['timelines', timelineId, 'next'])
    };
  };

  return mapStateToProps;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref4) {
  var timelineId = _ref4.timelineId,
      loadMore = _ref4.loadMore;
  return {

    onScrollToBottom: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_timelines__["C" /* scrollTopTimeline */])(timelineId, false));
      loadMore();
    }, 300, { leading: true }),

    onScrollToTop: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_timelines__["C" /* scrollTopTimeline */])(timelineId, true));
    }, 100),

    onScroll: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_timelines__["C" /* scrollTopTimeline */])(timelineId, false));
    }, 100)

  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_status_list__["a" /* default */]));

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export connectTimelineStream */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return connectUserStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectCommunityStream; });
/* unused harmony export connectMediaStream */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return connectPublicStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectHashtagStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectDirectStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timelines__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales__ = __webpack_require__(8);





var _getLocale = Object(__WEBPACK_IMPORTED_MODULE_3__locales__["getLocale"])(),
    messages = _getLocale.messages;

function connectTimelineStream(timelineId, path) {
  var pollingRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return function (dispatch, getState) {
    var streamingAPIBaseURL = getState().getIn(['meta', 'streaming_api_base_url']);
    var accessToken = getState().getIn(['meta', 'access_token']);
    var locale = getState().getIn(['meta', 'locale']);
    var polling = null;

    var setupPolling = function setupPolling() {
      polling = setInterval(function () {
        pollingRefresh(dispatch);
      }, 20000);
    };

    var clearPolling = function clearPolling() {
      if (polling) {
        clearInterval(polling);
        polling = null;
      }
    };

    var subscription = Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(streamingAPIBaseURL, accessToken, path, {
      connected: function connected() {
        if (pollingRefresh) {
          clearPolling();
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["l" /* connectTimeline */])(timelineId));
      },
      disconnected: function disconnected() {
        if (pollingRefresh) {
          setupPolling();
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["n" /* disconnectTimeline */])(timelineId));
      },
      received: function received(data) {
        switch (data.event) {
          case 'update':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["D" /* updateTimeline */])(timelineId, JSON.parse(data.payload)));
            break;
          case 'delete':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["m" /* deleteFromTimelines */])(data.payload));
            break;
          case 'notification':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["n" /* updateNotifications */])(JSON.parse(data.payload), messages, locale));
            break;
        }
      },
      reconnected: function reconnected() {
        if (pollingRefresh) {
          clearPolling();
          pollingRefresh(dispatch);
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["l" /* connectTimeline */])(timelineId));
      }
    });

    var disconnect = function disconnect() {
      if (subscription) {
        subscription.close();
      }
      clearPolling();
    };

    return disconnect;
  };
}

function refreshHomeTimelineAndNotification(dispatch) {
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["A" /* refreshHomeTimeline */])());
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["l" /* refreshNotifications */])());
}

var connectUserStream = function connectUserStream() {
  return connectTimelineStream('home', 'user', refreshHomeTimelineAndNotification);
};
var connectCommunityStream = function connectCommunityStream() {
  return connectTimelineStream('community', 'public:local');
};
var connectMediaStream = function connectMediaStream() {
  return connectTimelineStream('community', 'public:local');
};
var connectPublicStream = function connectPublicStream() {
  return connectTimelineStream('public', 'public');
};
var connectHashtagStream = function connectHashtagStream(tag) {
  return connectTimelineStream('hashtag:' + tag, 'hashtag&tag=' + tag);
};
var connectDirectStream = function connectDirectStream() {
  return connectTimelineStream('direct', 'direct');
};

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_websocket_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_websocket_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_websocket_js__);


function getStream(streamingAPIBaseURL, accessToken, stream, _ref) {
  var connected = _ref.connected,
      received = _ref.received,
      disconnected = _ref.disconnected,
      reconnected = _ref.reconnected;

  var ws = new __WEBPACK_IMPORTED_MODULE_0_websocket_js___default.a(streamingAPIBaseURL + '/api/v1/streaming/?access_token=' + accessToken + '&stream=' + stream);

  ws.onopen = connected;
  ws.onmessage = function (e) {
    return received(JSON.parse(e.data));
  };
  ws.onclose = disconnected;
  ws.onreconnect = reconnected;

  return ws;
};

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var backoff=__webpack_require__(315);var WebSocketClient=function(){/**
   * @param url DOMString The URL to which to connect; this should be the URL to which the WebSocket server will respond.
   * @param protocols DOMString|DOMString[] Either a single protocol string or an array of protocol strings. These strings are used to indicate sub-protocols, so that a single server can implement multiple WebSocket sub-protocols (for example, you might want one server to be able to handle different types of interactions depending on the specified protocol). If you don't specify a protocol string, an empty string is assumed.
   */function WebSocketClient(url,protocols){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};_classCallCheck(this,WebSocketClient);this.url=url;this.protocols=protocols;this.reconnectEnabled=true;this.listeners={};this.backoff=backoff[options.backoff||'fibonacci'](options);this.backoff.on('backoff',this.onBackoffStart.bind(this));this.backoff.on('ready',this.onBackoffReady.bind(this));this.backoff.on('fail',this.onBackoffFail.bind(this));this.open();}_createClass(WebSocketClient,[{key:'open',value:function open(){var reconnect=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;this.isReconnect=reconnect;this.ws=new WebSocket(this.url,this.protocols);this.ws.onclose=this.onCloseCallback.bind(this);this.ws.onerror=this.onErrorCallback.bind(this);this.ws.onmessage=this.onMessageCallback.bind(this);this.ws.onopen=this.onOpenCallback.bind(this);}/**
   * @ignore
   */},{key:'onBackoffStart',value:function onBackoffStart(number,delay){}/**
   * @ignore
   */},{key:'onBackoffReady',value:function onBackoffReady(number,delay){// console.log("onBackoffReady", number + ' ' + delay + 'ms');
this.open(true);}/**
   * @ignore
   */},{key:'onBackoffFail',value:function onBackoffFail(){}/**
   * @ignore
   */},{key:'onCloseCallback',value:function onCloseCallback(){if(!this.isReconnect&&this.listeners['onclose'])this.listeners['onclose'].apply(null,arguments);if(this.reconnectEnabled){this.backoff.backoff();}}/**
   * @ignore
   */},{key:'onErrorCallback',value:function onErrorCallback(){if(this.listeners['onerror'])this.listeners['onerror'].apply(null,arguments);}/**
   * @ignore
   */},{key:'onMessageCallback',value:function onMessageCallback(){if(this.listeners['onmessage'])this.listeners['onmessage'].apply(null,arguments);}/**
   * @ignore
   */},{key:'onOpenCallback',value:function onOpenCallback(){if(this.listeners['onopen'])this.listeners['onopen'].apply(null,arguments);if(this.isReconnect&&this.listeners['onreconnect'])this.listeners['onreconnect'].apply(null,arguments);this.isReconnect=false;}/**
   * The number of bytes of data that have been queued using calls to send()
   * but not yet transmitted to the network. This value does not reset to zero
   * when the connection is closed; if you keep calling send(), this will
   * continue to climb.
   *
   * @type unsigned long
   * @readonly
   */},{key:'close',/**
   * Closes the WebSocket connection or connection attempt, if any. If the
   * connection is already CLOSED, this method does nothing.
   *
   * @param code A numeric value indicating the status code explaining why the connection is being closed. If this parameter is not specified, a default value of 1000 (indicating a normal "transaction complete" closure) is assumed. See the list of status codes on the CloseEvent page for permitted values.
   * @param reason A human-readable string explaining why the connection is closing. This string must be no longer than 123 bytes of UTF-8 text (not characters).
   *
   * @return void
   */value:function close(code,reason){if(typeof code=='undefined'){code=1000;}this.reconnectEnabled=false;this.ws.close(code,reason);}/**
   * Transmits data to the server over the WebSocket connection.
   * @param data DOMString|ArrayBuffer|Blob
   * @return void
   */},{key:'send',value:function send(data){this.ws.send(data);}/**
   * An event listener to be called when the WebSocket connection's readyState changes to CLOSED. The listener receives a CloseEvent named "close".
   * @param listener EventListener
   */},{key:'bufferedAmount',get:function get(){return this.ws.bufferedAmount;}/**
   * The current state of the connection; this is one of the Ready state constants.
   * @type unsigned short
   * @readonly
   */},{key:'readyState',get:function get(){return this.ws.readyState;}/**
   * A string indicating the type of binary data being transmitted by the
   * connection. This should be either "blob" if DOM Blob objects are being
   * used or "arraybuffer" if ArrayBuffer objects are being used.
   * @type DOMString
   */},{key:'binaryType',get:function get(){return this.ws.binaryType;},set:function set(binaryType){this.ws.binaryType=binaryType;}/**
   * The extensions selected by the server. This is currently only the empty
   * string or a list of extensions as negotiated by the connection.
   * @type DOMString
   */},{key:'extensions',get:function get(){return this.ws.extensions;},set:function set(extensions){this.ws.extensions=extensions;}/**
   * A string indicating the name of the sub-protocol the server selected;
   * this will be one of the strings specified in the protocols parameter when
   * creating the WebSocket object.
   * @type DOMString
   */},{key:'protocol',get:function get(){return this.ws.protocol;},set:function set(protocol){this.ws.protocol=protocol;}},{key:'onclose',set:function set(listener){this.listeners['onclose']=listener;},get:function get(){return this.listeners['onclose'];}/**
   * An event listener to be called when an error occurs. This is a simple event named "error".
   * @param listener EventListener
   */},{key:'onerror',set:function set(listener){this.listeners['onerror']=listener;},get:function get(){return this.listeners['onerror'];}/**
   * An event listener to be called when a message is received from the server. The listener receives a MessageEvent named "message".
   * @param listener EventListener
   */},{key:'onmessage',set:function set(listener){this.listeners['onmessage']=listener;},get:function get(){return this.listeners['onmessage'];}/**
   * An event listener to be called when the WebSocket connection's readyState changes to OPEN; this indicates that the connection is ready to send and receive data. The event is a simple one with the name "open".
   * @param listener EventListener
   */},{key:'onopen',set:function set(listener){this.listeners['onopen']=listener;},get:function get(){return this.listeners['onopen'];}/**
   * @param listener EventListener
   */},{key:'onreconnect',set:function set(listener){this.listeners['onreconnect']=listener;},get:function get(){return this.listeners['onreconnect'];}}]);return WebSocketClient;}();/**
 * The connection is not yet open.
 */WebSocketClient.CONNECTING=WebSocket.CONNECTING;/**
 * The connection is open and ready to communicate.
 */WebSocketClient.OPEN=WebSocket.OPEN;/**
 * The connection is in the process of closing.
 */WebSocketClient.CLOSING=WebSocket.CLOSING;/**
 * The connection is closed or couldn't be opened.
 */WebSocketClient.CLOSED=WebSocket.CLOSED;exports.default=WebSocketClient;

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var Backoff = __webpack_require__(169);
var ExponentialBackoffStrategy = __webpack_require__(320);
var FibonacciBackoffStrategy = __webpack_require__(171);
var FunctionCall = __webpack_require__(321);

module.exports.Backoff = Backoff;
module.exports.FunctionCall = FunctionCall;
module.exports.FibonacciStrategy = FibonacciBackoffStrategy;
module.exports.ExponentialStrategy = ExponentialBackoffStrategy;

// Constructs a Fibonacci backoff.
module.exports.fibonacci = function(options) {
    return new Backoff(new FibonacciBackoffStrategy(options));
};

// Constructs an exponential backoff.
module.exports.exponential = function(options) {
    return new Backoff(new ExponentialBackoffStrategy(options));
};

// Constructs a FunctionCall for the given function and arguments.
module.exports.call = function(fn, vargs, callback) {
    var args = Array.prototype.slice.call(arguments);
    fn = args[0];
    vargs = args.slice(1, args.length - 1);
    callback = args[args.length - 1];
    return new FunctionCall(fn, vargs, callback);
};


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

var util = __webpack_require__(39);

var errors = module.exports = __webpack_require__(319);

function failCheck(ExceptionConstructor, callee, messageFormat, formatArgs) {
    messageFormat = messageFormat || '';
    var message = util.format.apply(this, [messageFormat].concat(formatArgs));
    var error = new ExceptionConstructor(message);
    Error.captureStackTrace(error, callee);
    throw error;
}

function failArgumentCheck(callee, message, formatArgs) {
    failCheck(errors.IllegalArgumentError, callee, message, formatArgs);
}

function failStateCheck(callee, message, formatArgs) {
    failCheck(errors.IllegalStateError, callee, message, formatArgs);
}

module.exports.checkArgument = function(value, message) {
    if (!value) {
        failArgumentCheck(arguments.callee, message,
            Array.prototype.slice.call(arguments, 2));
    }
};

module.exports.checkState = function(value, message) {
    if (!value) {
        failStateCheck(arguments.callee, message,
            Array.prototype.slice.call(arguments, 2));
    }
};

module.exports.checkIsDef = function(value, message) {
    if (value !== undefined) {
        return value;
    }

    failArgumentCheck(arguments.callee, message ||
        'Expected value to be defined but was undefined.',
        Array.prototype.slice.call(arguments, 2));
};

module.exports.checkIsDefAndNotNull = function(value, message) {
    // Note that undefined == null.
    if (value != null) {
        return value;
    }

    failArgumentCheck(arguments.callee, message ||
        'Expected value to be defined and not null but got "' +
        typeOf(value) + '".', Array.prototype.slice.call(arguments, 2));
};

// Fixed version of the typeOf operator which returns 'null' for null values
// and 'array' for arrays.
function typeOf(value) {
    var s = typeof value;
    if (s == 'object') {
        if (!value) {
            return 'null';
        } else if (value instanceof Array) {
            return 'array';
        }
    }
    return s;
}

function typeCheck(expect) {
    return function(value, message) {
        var type = typeOf(value);

        if (type == expect) {
            return value;
        }

        failArgumentCheck(arguments.callee, message ||
            'Expected "' + expect + '" but got "' + type + '".',
            Array.prototype.slice.call(arguments, 2));
    };
}

module.exports.checkIsString = typeCheck('string');
module.exports.checkIsArray = typeCheck('array');
module.exports.checkIsNumber = typeCheck('number');
module.exports.checkIsBoolean = typeCheck('boolean');
module.exports.checkIsFunction = typeCheck('function');
module.exports.checkIsObject = typeCheck('object');


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

var util = __webpack_require__(39);

function IllegalArgumentError(message) {
    Error.call(this, message);
    this.message = message;
}
util.inherits(IllegalArgumentError, Error);

IllegalArgumentError.prototype.name = 'IllegalArgumentError';

function IllegalStateError(message) {
    Error.call(this, message);
    this.message = message;
}
util.inherits(IllegalStateError, Error);

IllegalStateError.prototype.name = 'IllegalStateError';

module.exports.IllegalStateError = IllegalStateError;
module.exports.IllegalArgumentError = IllegalArgumentError;

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var util = __webpack_require__(39);
var precond = __webpack_require__(107);

var BackoffStrategy = __webpack_require__(170);

// Exponential backoff strategy.
function ExponentialBackoffStrategy(options) {
    BackoffStrategy.call(this, options);
    this.backoffDelay_ = 0;
    this.nextBackoffDelay_ = this.getInitialDelay();
    this.factor_ = ExponentialBackoffStrategy.DEFAULT_FACTOR;

    if (options && options.factor !== undefined) {
        precond.checkArgument(options.factor > 1,
            'Exponential factor should be greater than 1 but got %s.',
            options.factor);
        this.factor_ = options.factor;
    }
}
util.inherits(ExponentialBackoffStrategy, BackoffStrategy);

// Default multiplication factor used to compute the next backoff delay from
// the current one. The value can be overridden by passing a custom factor as
// part of the options.
ExponentialBackoffStrategy.DEFAULT_FACTOR = 2;

ExponentialBackoffStrategy.prototype.next_ = function() {
    this.backoffDelay_ = Math.min(this.nextBackoffDelay_, this.getMaxDelay());
    this.nextBackoffDelay_ = this.backoffDelay_ * this.factor_;
    return this.backoffDelay_;
};

ExponentialBackoffStrategy.prototype.reset_ = function() {
    this.backoffDelay_ = 0;
    this.nextBackoffDelay_ = this.getInitialDelay();
};

module.exports = ExponentialBackoffStrategy;


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var events = __webpack_require__(106);
var precond = __webpack_require__(107);
var util = __webpack_require__(39);

var Backoff = __webpack_require__(169);
var FibonacciBackoffStrategy = __webpack_require__(171);

// Wraps a function to be called in a backoff loop.
function FunctionCall(fn, args, callback) {
    events.EventEmitter.call(this);

    precond.checkIsFunction(fn, 'Expected fn to be a function.');
    precond.checkIsArray(args, 'Expected args to be an array.');
    precond.checkIsFunction(callback, 'Expected callback to be a function.');

    this.function_ = fn;
    this.arguments_ = args;
    this.callback_ = callback;
    this.lastResult_ = [];
    this.numRetries_ = 0;

    this.backoff_ = null;
    this.strategy_ = null;
    this.failAfter_ = -1;
    this.retryPredicate_ = FunctionCall.DEFAULT_RETRY_PREDICATE_;

    this.state_ = FunctionCall.State_.PENDING;
}
util.inherits(FunctionCall, events.EventEmitter);

// States in which the call can be.
FunctionCall.State_ = {
    // Call isn't started yet.
    PENDING: 0,
    // Call is in progress.
    RUNNING: 1,
    // Call completed successfully which means that either the wrapped function
    // returned successfully or the maximal number of backoffs was reached.
    COMPLETED: 2,
    // The call was aborted.
    ABORTED: 3
};

// The default retry predicate which considers any error as retriable.
FunctionCall.DEFAULT_RETRY_PREDICATE_ = function(err) {
  return true;
};

// Checks whether the call is pending.
FunctionCall.prototype.isPending = function() {
    return this.state_ == FunctionCall.State_.PENDING;
};

// Checks whether the call is in progress.
FunctionCall.prototype.isRunning = function() {
    return this.state_ == FunctionCall.State_.RUNNING;
};

// Checks whether the call is completed.
FunctionCall.prototype.isCompleted = function() {
    return this.state_ == FunctionCall.State_.COMPLETED;
};

// Checks whether the call is aborted.
FunctionCall.prototype.isAborted = function() {
    return this.state_ == FunctionCall.State_.ABORTED;
};

// Sets the backoff strategy to use. Can only be called before the call is
// started otherwise an exception will be thrown.
FunctionCall.prototype.setStrategy = function(strategy) {
    precond.checkState(this.isPending(), 'FunctionCall in progress.');
    this.strategy_ = strategy;
    return this; // Return this for chaining.
};

// Sets the predicate which will be used to determine whether the errors
// returned from the wrapped function should be retried or not, e.g. a
// network error would be retriable while a type error would stop the
// function call.
FunctionCall.prototype.retryIf = function(retryPredicate) {
    precond.checkState(this.isPending(), 'FunctionCall in progress.');
    this.retryPredicate_ = retryPredicate;
    return this;
};

// Returns all intermediary results returned by the wrapped function since
// the initial call.
FunctionCall.prototype.getLastResult = function() {
    return this.lastResult_.concat();
};

// Returns the number of times the wrapped function call was retried.
FunctionCall.prototype.getNumRetries = function() {
    return this.numRetries_;
};

// Sets the backoff limit.
FunctionCall.prototype.failAfter = function(maxNumberOfRetry) {
    precond.checkState(this.isPending(), 'FunctionCall in progress.');
    this.failAfter_ = maxNumberOfRetry;
    return this; // Return this for chaining.
};

// Aborts the call.
FunctionCall.prototype.abort = function() {
    if (this.isCompleted() || this.isAborted()) {
      return;
    }

    if (this.isRunning()) {
        this.backoff_.reset();
    }

    this.state_ = FunctionCall.State_.ABORTED;
    this.lastResult_ = [new Error('Backoff aborted.')];
    this.emit('abort');
    this.doCallback_();
};

// Initiates the call to the wrapped function. Accepts an optional factory
// function used to create the backoff instance; used when testing.
FunctionCall.prototype.start = function(backoffFactory) {
    precond.checkState(!this.isAborted(), 'FunctionCall is aborted.');
    precond.checkState(this.isPending(), 'FunctionCall already started.');

    var strategy = this.strategy_ || new FibonacciBackoffStrategy();

    this.backoff_ = backoffFactory ?
        backoffFactory(strategy) :
        new Backoff(strategy);

    this.backoff_.on('ready', this.doCall_.bind(this, true /* isRetry */));
    this.backoff_.on('fail', this.doCallback_.bind(this));
    this.backoff_.on('backoff', this.handleBackoff_.bind(this));

    if (this.failAfter_ > 0) {
        this.backoff_.failAfter(this.failAfter_);
    }

    this.state_ = FunctionCall.State_.RUNNING;
    this.doCall_(false /* isRetry */);
};

// Calls the wrapped function.
FunctionCall.prototype.doCall_ = function(isRetry) {
    if (isRetry) {
        this.numRetries_++;
    }
    var eventArgs = ['call'].concat(this.arguments_);
    events.EventEmitter.prototype.emit.apply(this, eventArgs);
    var callback = this.handleFunctionCallback_.bind(this);
    this.function_.apply(null, this.arguments_.concat(callback));
};

// Calls the wrapped function's callback with the last result returned by the
// wrapped function.
FunctionCall.prototype.doCallback_ = function() {
    this.callback_.apply(null, this.lastResult_);
};

// Handles wrapped function's completion. This method acts as a replacement
// for the original callback function.
FunctionCall.prototype.handleFunctionCallback_ = function() {
    if (this.isAborted()) {
        return;
    }

    var args = Array.prototype.slice.call(arguments);
    this.lastResult_ = args; // Save last callback arguments.
    events.EventEmitter.prototype.emit.apply(this, ['callback'].concat(args));

    var err = args[0];
    if (err && this.retryPredicate_(err)) {
        this.backoff_.backoff(err);
    } else {
        this.state_ = FunctionCall.State_.COMPLETED;
        this.doCallback_();
    }
};

// Handles the backoff event by reemitting it.
FunctionCall.prototype.handleBackoff_ = function(number, delay, err) {
    this.emit('backoff', number, delay, err);
};

module.exports = FunctionCall;


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(317);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(318);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(62)))

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PublicTimeline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_containers_status_list_container__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_column__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_column_header__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_timelines__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_columns__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_column_settings_container__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_streaming__ = __webpack_require__(312);





var _dec, _class;













var messages = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["f" /* defineMessages */])({
  title: {
    'id': 'column.public',
    'defaultMessage': 'Federated timeline'
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasUnread: state.getIn(['timelines', 'public', 'unread']) > 0
  };
};

var PublicTimeline = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps), _dec(_class = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["g" /* injectIntl */])(_class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PublicTimeline, _React$PureComponent);

  function PublicTimeline() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PublicTimeline);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handlePin = function () {
      var _this$props = _this.props,
          columnId = _this$props.columnId,
          dispatch = _this$props.dispatch;


      if (columnId) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_columns__["f" /* removeColumn */])(columnId));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_columns__["d" /* addColumn */])('PUBLIC', {}));
      }
    }, _this.handleMove = function (dir) {
      var _this$props2 = _this.props,
          columnId = _this$props2.columnId,
          dispatch = _this$props2.dispatch;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_columns__["e" /* moveColumn */])(columnId, dir));
    }, _this.handleHeaderClick = function () {
      _this.column.scrollTop();
    }, _this.setRef = function (c) {
      _this.column = c;
    }, _this.handleLoadMore = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_timelines__["u" /* expandPublicTimeline */])());
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  PublicTimeline.prototype.componentDidMount = function componentDidMount() {
    var dispatch = this.props.dispatch;


    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_timelines__["B" /* refreshPublicTimeline */])());
    this.disconnect = dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_streaming__["d" /* connectPublicStream */])());
  };

  PublicTimeline.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.disconnect) {
      this.disconnect();
      this.disconnect = null;
    }
  };

  PublicTimeline.prototype.render = function render() {
    var _props = this.props,
        intl = _props.intl,
        columnId = _props.columnId,
        hasUnread = _props.hasUnread,
        multiColumn = _props.multiColumn;

    var pinned = !!columnId;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__components_column__["a" /* default */],
      { ref: this.setRef },
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__components_column_header__["a" /* default */], {
        icon: 'globe',
        active: hasUnread,
        title: intl.formatMessage(messages.title),
        onPin: this.handlePin,
        onMove: this.handleMove,
        onClick: this.handleHeaderClick,
        pinned: pinned,
        multiColumn: multiColumn
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__containers_column_settings_container__["a" /* default */], {})),
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_containers_status_list_container__["a" /* default */], {
        timelineId: 'public',
        loadMore: this.handleLoadMore,
        trackScroll: !pinned,
        scrollKey: 'public_timeline-' + columnId,
        emptyMessage: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_intl__["b" /* FormattedMessage */], {
          id: 'empty_column.public',
          defaultMessage: 'There is nothing here! Write something publicly, or manually follow users from other instances to fill it up'
        })
      })
    );
  };

  return PublicTimeline;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent)) || _class) || _class);


/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var SettingText = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SettingText, _React$PureComponent);

  function SettingText() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SettingText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleChange = function (e) {
      _this.props.onChange(_this.props.settingKey, e.target.value);
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  SettingText.prototype.render = function render() {
    var _props = this.props,
        settings = _props.settings,
        settingKey = _props.settingKey,
        label = _props.label;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('label', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      style: { display: 'none' }
    }, void 0, label), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('input', {
      className: 'setting-text',
      value: settings.getIn(settingKey),
      onChange: this.handleChange,
      placeholder: label
    }));
  };

  return SettingText;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_setting_text__ = __webpack_require__(806);





var _class;






var messages = Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* defineMessages */])({
  filter_regex: {
    'id': 'home.column_settings.filter_regex',
    'defaultMessage': 'Filter out by regular expressions'
  },
  settings: {
    'id': 'home.settings',
    'defaultMessage': 'Column settings'
  }
});

var ColumnSettings = Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["g" /* injectIntl */])(_class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ColumnSettings, _React$PureComponent);

  function ColumnSettings() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSettings);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.apply(this, arguments));
  }

  ColumnSettings.prototype.render = function render() {
    var _props = this.props,
        settings = _props.settings,
        onChange = _props.onChange,
        intl = _props.intl;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      className: 'column-settings__section'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'home.column_settings.advanced',
      defaultMessage: 'Advanced'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-settings__row'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__components_setting_text__["a" /* default */], {
      settings: settings,
      settingKey: ['regex', 'body'],
      onChange: onChange,
      label: intl.formatMessage(messages.filter_regex)
    })));
  };

  return ColumnSettings;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent)) || _class;



/***/ })

});


// WEBPACK FOOTER //
// features/public_timeline-e4ae46a87dc3bc8a32b5.js